import OptionSelector from './option-selector';

export default OptionSelector;